import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useLanguage } from "@/contexts/LanguageContext";
import { cn } from "@/lib/utils";
import { useIntl } from "react-intl";

export default function LanguageSelector({
  className,
}: {
  className?: string;
}) {
  const { language, setLanguage } = useLanguage();
  const intl = useIntl();

  return (
    <Select value={language} onValueChange={setLanguage}>
      <SelectTrigger
        aria-label={intl.formatMessage({ id: "language.select" })}
        className={cn("w-[132px]", className)}
        data-testid="language-selector"
      >
        <SelectValue
          placeholder={intl.formatMessage({ id: "language.select" })}
        />
      </SelectTrigger>
      <SelectContent>
        <SelectItem
          value="en"
          data-testid="language-option-en"
          onClick={() => setLanguage("en")}
        >
          {intl.formatMessage({ id: "language.en" })}
        </SelectItem>
        <SelectItem
          value="de"
          data-testid="language-option-de"
          onClick={() => setLanguage("de")}
        >
          {intl.formatMessage({ id: "language.de" })}
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
